
import { createWebHistory, createRouter } from "vue-router";
import Login from "../views/auth/LoginPage";
import Home from "../views/HomePage";
import ResetPassword from "../views/auth/ResetPassword.vue";
import AddSupplier from "@/views/supplier/AddSupplier.vue";
import AddTenderCategory from "@/views/supplier/AddTenderCategory.vue";
import Suppliers from "@/views/supplier/Suppliers.vue";
import ViewSupplier from "@/views/supplier/ViewSupplier.vue";
import BulkUploadSuppliers from "@/views/supplier/BulkUploadSuppliers.vue";
import Warehouses from "@/views/warehouse/Warehouses.vue";
import AddWarehouse from "@/views/warehouse/AddWarehouse.vue";
import ViewWarehouse from "@/views/warehouse/ViewWarehouse.vue";
import VirtualWarehouse from "@/views/warehouse/VirtualWarehouse.vue";
import ProductWarehouse from "@/views/warehouse/ProductWarehouse.vue";
import LocateWarehouse from "../views/warehouse/LocateWarehouse.vue";
import ProductActivity from "../views/warehouse/ProductActivity.vue";
import AddProduct from "../views/inventory/products/AddProduct.vue";
import ViewProducts from "../views/inventory/products/ViewAllProducts.vue";
import ViewProduct from "../views/inventory/products/ViewProduct.vue";
import EditProduct from "../views/inventory/products/EditProduct.vue";
import BulkUploadProducts from "../views/inventory/products/BulkUploadProducts.vue";
import ManageStocks from "../views/inventory/ManageStock.vue";
import StockAdjustment from '../views/inventory/StockAdjustment.vue';

// Tender imports
import PublicTenders from "../views/PublicTenders.vue";
import TenderDetail from "../views/TenderDetail.vue";
import TenderManagement from "../views/admin/TenderManagement.vue";
import AddTender from "../views/admin/AddTender.vue";
import AllTenderSubmissions from "../views/admin/AllTenderSubmissions.vue";
import EmailLogs from "../views/admin/EmailLogs.vue";
import SubmissionManagement from "../views/admin/SubmissionManagement.vue";
import StockAdjustments from '../views/inventory/StockAdjustments.vue';
import StockTransfer from '../views/inventory/StockTransfer.vue';
import StockTransfers from '../views/inventory/StockTransfers.vue';
import StockReserved from '../views/inventory/StockReserved.vue';
import StockReserveds from '../views/inventory/StockReserveds.vue';
import StockReservedActivity from '../views/inventory/StockReservedActivity.vue';
import MarkedReturn from '../views/inventory/MarkedReturn.vue';
import Transaction from "../views/transaction/HomeTransactions.vue";
import AddBatch from "../views/transaction/batch/AddBatch.vue";
import SavedBatch from "../views/transaction/batch/SavedBatch.vue";
import ProcessedBatch from "../views/transaction/batch/ProcessedBatch.vue";
import PdfBatch from "../views/transaction/batch/PdfBatch.vue";
import IncompleteDelivery from "../views/transaction/idn/IncompleteDelivery.vue";
import AddIncompleteDelivery from "../views/transaction/idn/AddIncompleteDelivery.vue";
import PdfIncompleteDelivery from "../views/transaction/idn/IdnPdf.vue";

// Purchase Request imports
import PurchaseRequestList from "../views/transaction/purchase-request/PurchaseRequestList.vue";
import AddPurchaseRequest from "../views/transaction/purchase-request/AddPurchaseRequest.vue";
import ViewPurchaseRequest from "../views/transaction/purchase-request/ViewPurchaseRequest.vue";
import SettingsMainPage from "../views/settings/Main.vue";
import SettingsCategory from "../views/settings/Categories.vue";
import SettingsBusinessProfile from "../views/settings/ProfileView.vue";
import SettingsUserProfile from "../views/settings/UserProfileView.vue";
import SettingsUsers from "../views/settings/Users.vue";
import SettingsUser from "../views/settings/User.vue";
import SettingsApprovals from "../views/settings/ApprovalsHome.vue";
import SettingsApprovalsPending from "../views/settings/ApprovalsPending.vue";
import SettingsRoles from "../views/settings/RolesOverview.vue";
import SettingsRole from "../views/settings/RoleEdit.vue";
import SettingsNotification from "../views/settings/NotificationsHome.vue"
import SettingsBilling from "../views/settings/BillingHome.vue"
import SettingsAudit from "../views/settings/AuditLog.vue"
import SettingsDocumentFormat from "../views/settings/DocumentFormat.vue"
import SettingsDevicManagement from "../views/settings/DeviceManagement.vue"
import HomePurchase from "../views/purchase/HomePurchases.vue";
import AddPurchase from "../views/purchase/AddPurchase.vue";
import PdfPurchase from "../views/purchase/PdfPurchase.vue";
import CreditPaymentsDashboard from "../views/purchase/ProcurementDashboard.vue";
import Orders from "../views/order/HomeOrders.vue";
import CancelledOrders from "../views/order/CancelledOrders.vue";
import AddPickup from "../views/order/pickup/AddPickup.vue";
import ProcessPickup from "../views/order/pickup/ProcessPickup.vue";
import PickupPdf from "../views/order/pickup/PickupPdf.vue";
import GatePickup from "../views/order/pickup/GatePickup.vue";
import AddDispatch from "../views/order/dispatch/AddDispatch.vue";
import ProcessDispatch from "../views/order/dispatch/ProcessDispatch.vue";
import PdfDispatch from "../views/order/dispatch/PdfDispatch.vue";
import GateDispatch from "../views/order/dispatch/GateDispatch.vue";
import ReportsHome from "../views/reports/ReportsHome.vue";
import ProcurementReport from "../views/reports/ProcurementReport.vue";
import CommingSoon from "../views/supplementary/CommingSoon.vue"
import Departments from "@/views/settings/Departments.vue";
import ProcessedOrders from "@/views/order/ProcessedOrders.vue";
import DeliveryPickup from "@/views/order/pickup/DeliveryPickup.vue";
import DeliveryDispatch from "@/views/order/dispatch/DeliveryDispatch.vue";
import BDDashboard from "@/views/admin/PerformanceMonitoring/BDDashboard.vue";
import ProcurementDashboard from "@/views/admin/PerformanceMonitoring/ProcurementDashboard.vue";
import ProcurementLayout from "@/components/ProcurementLayout.vue";
import ComplianceDocuments from "@/views/settings/ComplianceDocuments.vue";
import BidOpportunitiesList from "@/views/admin/Bid/OpportunitiesList.vue";
import BidOpportunityDetail from "@/views/admin/Bid/OpportunityDetail.vue";
import BidOpportunityCreate from "@/views/admin/Bid/OpportunityCreate.vue";
import BidClients from "@/views/admin/Bid/Clients.vue";
import BidClientDetail from "@/views/admin/Bid/ClientDetail.vue";
import Contracts from "@/views/admin/Bid/Contracts.vue";
import ContractDetail from "@/views/admin/Bid/ContractDetail.vue";
import LossRecords from "@/views/admin/LossRecords.vue";
import BidChecklistsOverview from "@/views/admin/Bid/BidChecklistsOverview.vue";
import ApproversOverview from "@/views/settings/ApproversOverview.vue";
import ServicesSettings from "@/views/settings/Services.vue";
import CreditPeriodDashboard from "@/views/procurement/CreditPeriodDashboard.vue";
import FleetDashboard from "@/views/fleet/FleetDashboard.vue";
import FleetVehicles from "@/views/fleet/FleetVehicles.vue";
import FleetDrivers from "@/views/fleet/FleetDrivers.vue";
import FleetTrips from "@/views/fleet/FleetTrips.vue";
import FleetFuel from "@/views/fleet/FleetFuel.vue";
import FleetCompliance from "@/views/fleet/FleetCompliance.vue";
import FleetVehicleDetail from "@/views/fleet/FleetVehicleDetail.vue";
import FleetTripDetail from "@/views/fleet/FleetTripDetail.vue";
import FleetFuelDetail from "@/views/fleet/FleetFuelDetail.vue";
import FleetComplianceDetail from "@/views/fleet/FleetComplianceDetail.vue";
import FleetSettings from "@/views/fleet/FleetSettings.vue";
import FleetMaintenance from "@/views/fleet/FleetMaintenance.vue";
import FleetDriverAssignments from "@/views/fleet/FleetDriverAssignments.vue";
import ApprovalsAwaiting from "@/views/settings/ApprovalsAwaiting.vue";
// procurement-specific scaffold views were removed; links point to existing routes

// const permission = JSON.parse(localStorage.getItem('permission'))

const routes = [
    {
        path: "/",
        name: "Login",
        component: Login,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        component: ResetPassword,
        meta: { title: 'Reset Password', public: true }
    },
    {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet",
        name: "FleetDashboard",
        component: FleetDashboard,
        meta: {
            title: 'Fleet Operations - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/vehicles",
        name: "FleetVehicles",
        component: FleetVehicles,
        meta: {
            title: 'Fleet Vehicles - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/drivers",
        name: "FleetDrivers",
        component: FleetDrivers,
        meta: {
            title: 'Fleet Drivers - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/trips",
        name: "FleetTrips",
        component: FleetTrips,
        meta: {
            title: 'Fleet Trips - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/fuel",
        name: "FleetFuel",
        component: FleetFuel,
        meta: {
            title: 'Fleet Fuel - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/compliance",
        name: "FleetCompliance",
        component: FleetCompliance,
        meta: {
            title: 'Fleet Compliance - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/settings",
        name: "FleetSettings",
        component: FleetSettings,
        meta: {
            title: 'Fleet Settings - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/maintenance",
        name: "FleetMaintenance",
        component: FleetMaintenance,
        meta: {
            title: 'Fleet Maintenance - Pavicon ERP',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/driver-assignments",
        name: "FleetDriverAssignments",
        component: FleetDriverAssignments,
        meta: {
            title: 'Driver Assignments - Pavicon ERP',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/vehicles/:id",
        name: "FleetVehicleDetail",
        component: FleetVehicleDetail,
        meta: {
            title: 'Vehicle Detail - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/trips/:id",
        name: "FleetTripDetail",
        component: FleetTripDetail,
        meta: {
            title: 'Trip Detail - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/fuel/:id",
        name: "FleetFuelDetail",
        component: FleetFuelDetail,
        meta: {
            title: 'Fuel Detail - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/fleet/compliance/:id",
        name: "FleetComplianceDetail",
        component: FleetComplianceDetail,
        meta: {
            title: 'Compliance Detail - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    {
        path: "/admin/bid/checklists",
        name: "BidChecklistsOverview",
        component: BidChecklistsOverview,
        meta: {
            title: 'Bid Checklists Overview',
            permission: 'bdBidPreparation'
        }
    },
    {
        path: "/admin/loss-records",
        name: "LossRecords",
        component: LossRecords,
        meta: {
            title: 'Loss Records',
            permission: 'bdOpportunitiesManage'
        }
    },
    {
        path: "/admin/bid/clients",
        name: "BidClients",
        component: BidClients,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'bdOpportunitiesManage'
        }
    },
    {
        path: "/admin/bid/clients/:id",
        name: "BidClientDetail",
        component: BidClientDetail,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/inventory/products",
        name: "ViewProducts",
        component: ViewProducts,
        meta: {
            title: 'Pavicon ERP ',
            keepAlive: false
        }
    },
    {
        path: "/inventory/products/add",
        name: "AddProduct",
        component: AddProduct,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'productsManage'
        }
    },
    {
        path: "/inventory/products/bulk-upload",
        name: "BulkUploadProducts",
        component: BulkUploadProducts,
        meta: {
            title: 'Bulk Upload Products',
            permission: 'productsManage'
        }
    },
    {
        path: "/inventory/products/:id",
        params:"id",
        name: "ViewProduct",
        component: ViewProduct,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'productsManage'
        }
    },
    {
        path: "/inventory/products/edit/:id",
        params:"id",
        name: "EditProduct",
        component: EditProduct,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'productsManage'
        }
    },
    {
        path: "/inventory/stocks",
        name: "ManageStocks",
        component: ManageStocks,
        meta: {
            title: 'Pavicon ERP ',
            keepAlive: false
        }
    },
    {
        path: "/inventory/stocks/adjustments",
        name: "StockAdjustments",
        component: StockAdjustments,
        meta: {
            title: 'Pavicon ERP '
        }  
    },
    {
        path: "/inventory/stocks/adjustments/:id",
        params:"id",
        name: "StockAdjustment",
        component: StockAdjustment,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/inventory/stocks/transfers",
        name: "StockTransfers",
        component: StockTransfers,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/inventory/stocks/transfers/:id",
        params:"id",
        name: "StockTransfer",
        component: StockTransfer,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/inventory/stocks/reserveds",
        name: "StockReserveds",
        component: StockReserveds,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/inventory/stocks/reserveds/:id",
        params:"id",
        name: "StockReservedActivity",
        component: StockReservedActivity,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/inventory/stocks/reserved/:id",
        params:"id",
        name: "StockReserved",
        component: StockReserved,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/inventory/stocks/markedreturn",
        name: "MarkedReturn",
        component: MarkedReturn,
        meta: {
            title: 'Pavicon ERP '
        }
        
    },
    {
        path: "/transaction",
        name: "Transaction",
        component: Transaction,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'transaction'
        }
    },
    {
        path: "/transaction/addbatch",
        name: "AddBatch",
        component: AddBatch,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'batchAdd'
        }
    },
    {
        path: "/transaction/savedbatch/:id",
        params:"id",
        name: "SavedBatch",
        component: SavedBatch,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'transaction'
        }
    },
    {
        path: "/transaction/processedbatch/:id",
        params:"id",
        name: "ProcessedBatch",
        component: ProcessedBatch,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'batchVerify'
        }
    },
    {
        path: "/transaction/pdfbatch/:id",
        params:"id",
        name: "PdfBatch",
        component: PdfBatch,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'transaction'
        }
    },
    {
        path: "/transaction/incompletenotes",
        name: "IncompleteDelivery",
        component: IncompleteDelivery,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'transaction'
        }
    },
    {
        path: "/transaction/incompletenotes/add",
        name: "AddIncompleteDelivery",
        component: AddIncompleteDelivery,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'transaction'
        }
    },
    {
        path: "/transaction/incompletenotes/pdf/:id",
        params:"id",
        name: "PdfIncompleteDelivery",
        component: PdfIncompleteDelivery,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'transaction'
        }
    },
    // Purchase Request routes
    {
        path: "/transaction/purchase-request",
        name: "PurchaseRequestList",
        component: PurchaseRequestList,
        meta: {
            title: 'Purchase Requests - Pavicon ERP ',
            permission: 'transaction'
        }
    },
    {
        path: "/transaction/purchase-request/add",
        name: "AddPurchaseRequest",
        component: AddPurchaseRequest,
        meta: {
            title: 'New Purchase Request - Pavicon ERP ',
            permission: 'transaction'
        }
    },
    {
        path: "/transaction/purchase-request/edit/:id",
        params:"id",
        name: "EditPurchaseRequest",
        component: AddPurchaseRequest,
        meta: {
            title: 'Edit Purchase Request - Pavicon ERP ',
            permission: 'transaction'
        }
    },
    {
        path: "/transaction/purchase-request/view/:id",
        params:"id",
        name: "ViewPurchaseRequest",
        component: ViewPurchaseRequest,
        meta: {
            title: 'Purchase Request Details - Pavicon ERP ',
            permission: 'transaction'
        }
    },
    
    {
        path: "/suppliers",
        name: "Suppliers",
        component: Suppliers,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'supplierView'

        }
    },
    {
        path: "/suppliers/add",
        name: "AddSupplier",
        component: AddSupplier,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'supplierAdd'
        }
    },
    {
        path: "/suppliers/tender-categories/add",
        name: "AddTenderCategory",
        component: AddTenderCategory,
        meta: {
            title: 'Add Procurement Categories - Pavicon ERP ',
            permission: 'supplierAdd'
        }
    },
    {
        path: "/suppliers/bulk",
        name: "BulkUploadSuppliers",
        component: BulkUploadSuppliers,
        meta: {
            title: 'Bulk Upload Suppliers',
            permission: 'supplierAdd'
        }
    },
    {
        path: "/suppliers/:id",
        params:"id",
        name: "ViewSupplier",
        component: ViewSupplier,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'supplierView'
        }
        
    },
    {
        path: "/orders/process",
        name: "Orders",
        component: Orders,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/orders",
        name: "ProcessOrders",
        component: ProcessedOrders,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/orders/cancelled",
        name: "CancelledOrders",
        component: CancelledOrders,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/orders/pickup/add",
        name: "AddPickup",
        component: AddPickup,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'pickupAdd'
        }
    },
    {
        path: "/orders/pickup/process/:id",
        params:"id",
        name: "ProcessPickup",
        component: ProcessPickup,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'pickupProcess'
        }
    },
    {
        path: "/orders/pickup/pdf/:id",
        params:"id",
        name: "PickupPdf",
        component: PickupPdf,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/orders/pickup/gate/:id",
        params:"id",
        name: "GatePickup",
        component: GatePickup,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/orders/pickup/delivery/:id",
        params:"id",
        name: "Pickup Delivery",
        component: DeliveryPickup,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/orders/dispatch/delivery/:id",
        params:"id",
        name: "Dispatch Delivery",
        component: DeliveryDispatch,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/orders/dispatch/add",
        name: "AddDispatch",
        component: AddDispatch,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'dispatchAdd'
        }
    },
    {
        path: "/orders/dispatch/process/:id",
        params:"id",
        name: "ProcessDispatch",
        component: ProcessDispatch,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'dispatchProcess'
        }
    },
    {
        path: "/orders/dispatch/pdf/:id",
        params:"id",
        name: "PdfDispatch",
        component: PdfDispatch,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/orders/dispatch/gate/:id",
        params:"id",
        name: "GateDispatch",
        component: GateDispatch,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/warehouses",
        name: "Warehouses",
        component: Warehouses,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/warehouses/add",
        name: "AddWarehouse",
        component: AddWarehouse,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'warehouseAdd'
        }
    },
    {
        path: "/warehouses/virtual",
        name: "VirtualWarehouse",
        component: VirtualWarehouse,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/warehouses/locate",
        name: "LocateWarehouse",
        component: LocateWarehouse,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/warehouses/activity/:id",
        params:"id",
        name: "ProductActivity",
        component: ProductActivity,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/warehouses/view/:id",
        params:"id",
        name: "ViewWarehouse",
        component: ViewWarehouse,
        meta: {
        title: 'Pavicon ERP '
        }
    },
    {
        path: "/warehouses/product/:id/:type/:title",
        props: true,
        name: "ProductWarehouse",
        component: ProductWarehouse,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/purchases",
        name: "Purchases",
        component: HomePurchase,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/purchases/credit-dashboard",
        name: "CreditPaymentsDashboard",
        component: CreditPaymentsDashboard,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/comming-soon",
        name: "Comming Soon",
        component: CommingSoon,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/purchases/add",
        name: "AddPurchase",
        component: AddPurchase,
        meta: {
            title: 'Pavicon ERP ',
            permission: 'purchaseAdd'
        }
    },
    {
        path: "/purchases/pdf/:id",
        params:"id",
        name: "PdfPurchase",
        component: PdfPurchase,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/settings",
        name: "SettingsMain",
        component: SettingsMainPage,
        meta: {
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/settings/categories",
        name: "SettingsCategory",
        component: SettingsCategory,
        meta:{ 
            title: 'Pavicon ERP ',
        }
    },
    {
        path: "/settings/audit",
        name: "SettingsAudit",
        component: SettingsAudit,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/settings/billing",
        name: "SettingsBilling",
        component: SettingsBilling,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/settings/document-types",
        name: "SettingsDocumentTypes",
        component: SettingsDocumentFormat,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/settings/compliance",
        name: "SettingsCompliance",
        component: ComplianceDocuments,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/settings/device-management",
        name: "SettingsDeviceManagement",
        component: SettingsDevicManagement,
        meta:{ title: 'Pavicon ERP '}
    },
    
    {
        path: "/settings/notifications",
        name: "SettingsNotification",
        component: SettingsNotification,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/settings/business-profile",
        name: "SettingsBusinessDetail",
        component: SettingsBusinessProfile,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/settings/profile",
        name: "SettingsProfile",
        component: SettingsUserProfile,
        meta:{ 
            title: 'Pavicon ERP '
        }
    },
    {
        path: "/settings/users",
        name: "SettingsUsers",
        component: SettingsUsers,
        meta:{ 
            title: 'Pavicon ERP ',
            permission: 'usersView'
        }
    },
    {
        path: "/settings/users/:id",
        params:"id",
        name: "ViewUser",
        component: SettingsUser,
        meta:{ 
            title: 'Pavicon ERP ',
            permission: 'usersManage'
        }
    },
    {
        path: "/settings/approvals",
        name: "SettingsApprovals",
        component: SettingsApprovals,
        meta:{ 
            title: 'Pavicon ERP ',
            permission: 'approveTransfer'
        }
    },
    {
        path: "/settings/departments",
        name: "SettingsDepartments",
        component: Departments,
        meta:{ 
            title: 'Pavicon ERP ',
            permission: 'approveTransfer'
        }
    },
    {
        path: "/settings/approvers",
        name: "SettingsApprovers",
        component: ApproversOverview,
        meta:{
            title: 'Approvers Overview',
            permission: 'approveTransfer'
        }
    },
    {
        path: "/settings/services",
        name: "SettingsServices",
        component: ServicesSettings,
        meta:{
            title: 'Manage Services',
            permission: 'approveTransfer'
        }
    },
    {
        path: "/settings/approvals/pending",
        name: "SettingsApprovalsPending",
        component: SettingsApprovalsPending,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/settings/approvals/awaiting",
        name: "SettingsApprovalsAwaiting",
        component: ApprovalsAwaiting,
        meta:{ title: 'Approvals Tracking'}
    },
    {
        path: "/settings/roles",
        name: "SettingsRoles",
        component: SettingsRoles,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/settings/roles/:id",
        params:"id",
        name: "SettingsRole",
        component: SettingsRole,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/reports",
        name: "ReportsHome",
        component: ReportsHome,
        meta:{ title: 'Pavicon ERP '}
    },
    {
        path: "/reports/procurement",
        name: "ProcurementReport",
        component: ProcurementReport,
        meta:{ title: 'Procurement Costs Report'}
    },
    // Business Development analytics (Module 6)
    {
        path: "/admin/bid/analytics",
        name: "BDDashboard",
        component: BDDashboard,
        meta: {
            title: 'BD Analytics - Pavicon ERP ',
            permission: 'bdOpportunitiesManage'
        }
    },
    // Procurement analytics dashboard
    {
        path: "/admin/procurement/analytics",
        name: "ProcurementDashboard",
        component: ProcurementDashboard,
        meta: {
            title: 'Procurement Analytics - Pavicon ERP ',
            permission: 'dashboard'
        }
    },
    // Procurement routes rendered inside ProcurementLayout (dashboard uses normal layout at /admin/procurement/analytics)
    {
        path: "/procurement",
        component: ProcurementLayout,
        children: [
            {
                path: "",
                redirect: "/admin/procurement/analytics"
            },
            {
                path: "dashboard",
                redirect: "/admin/procurement/analytics"
            },
            {
                path: "purchase-requests",
                name: "ProcurementPurchaseRequests",
                component: PurchaseRequestList,
                meta: { title: 'Purchase Requests - Procurement' }
            },
            {
                path: "purchase-requests/add",
                name: "ProcurementAddPurchaseRequest",
                component: AddPurchaseRequest,
                meta: { title: 'New Purchase Request - Procurement' }
            },
            {
                path: "tenders",
                name: "ProcurementTenders",
                component: TenderManagement,
                meta: { title: 'Tenders - Procurement' }
            },
            {
                path: "tenders/add",
                name: "ProcurementAddTender",
                component: AddTender,
                meta: { title: 'Add Tender - Procurement' }
            },
            {
                path: "tenders/submissions",
                name: "ProcurementTenderSubmissions",
                component: AllTenderSubmissions,
                meta: { title: 'Tender Submissions - Procurement' }
            },
            {
                path: "suppliers",
                name: "ProcurementSuppliers",
                component: Suppliers,
                meta: { title: 'Suppliers - Procurement' }
            },
            {
                path: "suppliers/add",
                name: "ProcurementAddSupplier",
                component: AddSupplier,
                meta: { title: 'Add Supplier - Procurement' }
            },
            {
                path: "purchases",
                name: "ProcurementPurchases",
                component: HomePurchase,
                meta: { title: 'Purchases - Procurement' }
            },
            {
                path: "purchases/add",
                name: "ProcurementAddPurchase",
                component: AddPurchase,
                meta: { title: 'Add Purchase - Procurement' }
            },
            {
                path: "credit-dashboard",
                name: "CreditPeriodDashboard",
                component: CreditPeriodDashboard,
                meta: { title: 'Credit Period Dashboard - Procurement' }
            }
        ]
    },
    {
        path: "/admin/bid/opportunities/new",
        name: "BidOpportunityCreate",
        component: BidOpportunityCreate,
        meta: {
            title: 'Business Development - New Opportunity',
            permission: 'bdOpportunitiesManage'
        }
    },
    // Business Development / BID module
    {
        path: "/admin/bid/opportunities",
        name: "BidOpportunitiesList",
        component: BidOpportunitiesList,
        meta: {
            title: 'BID Opportunities - Pavicon ERP ',
            permission: 'bdOpportunitiesManage'
        }
    },
    {
        path: "/admin/bid/opportunities/:id",
        params: "id",
        name: "BidOpportunityDetail",
        component: BidOpportunityDetail,
        meta: {
            title: 'BID Opportunity Detail - Pavicon ERP ',
            permission: 'bdOpportunitiesManage'
        }
    },
    {
        path: "/admin/bid/contracts",
        name: "BidContracts",
        component: Contracts,
        meta: {
            title: 'Contracts - Pavicon ERP ',
            permission: 'bdContractHandover'
        }
    },
    {
        path: "/admin/bid/contracts/:id",
        params: "id",
        name: "ContractDetail",
        component: ContractDetail,
        meta: {
            title: 'Contract Detail - Pavicon ERP ',
            permission: 'bdContractHandover'
        }
    },
    
    // Public tender routes
    {
        path: "/tenders",
        name: "PublicTenders",
        component: PublicTenders,
        meta: { 
            title: 'Public Tenders',
            public: true 
        }
    },
    {
        path: "/tenders/:slug",
        name: "TenderDetail",
        component: TenderDetail,
        props: true,
        meta: { 
            title: 'Tender Details',
            public: true 
        }
    },
    
    // Admin tender routes
    {
        path: "/admin/tenders",
        name: "TenderManagement",
        component: TenderManagement,
        meta: { 
            title: 'Tender Management',
            permission: 'dashboard'
        }
    },
    {
        path: "/admin/tenders/add",
        name: "AddTender",
        component: AddTender,
        meta: { 
            title: 'Add Tender',
            permission: 'dashboard'
        }
    },
    {
        path: "/admin/tenders/submissions",
        name: "AllTenderSubmissions",
        component: AllTenderSubmissions,
        meta: { 
            title: 'All Tender Submissions',
            permission: 'dashboard'
        }
    },
    {
        path: "/admin/email-logs",
        name: "EmailLogs",
        component: EmailLogs,
        meta: {
            title: 'Email Logs',
            permission: 'dashboard'
        }
    },
    {
        path: "/admin/tenders/:id/edit",
        name: "EditTender",
        component: AddTender,
        props: true,
        meta: { 
            title: 'Edit Tender',
            permission: 'dashboard'
        }
    },
    {
        path: "/admin/tenders/:id",
        name: "AdminTenderDetail",
        component: TenderDetail,
        props: true,
        meta: { 
            title: 'Tender Details',
            permission: 'dashboard'
        }
    },
    {
        path: "/admin/tenders/:id/submissions",
        name: "SubmissionManagement",
        component: SubmissionManagement,
        props: true,
        meta: { 
            title: 'Tender Submissions',
            permission: 'dashboard'
        }
    },

];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    window.document.title = to.meta?.title || 'Home';
    // Allow login page and public routes without auth
    if (to.path === '/' || to.meta?.public) return next();
    const token = localStorage.getItem('access_token');
    if (!token) return next('/');
    // Apply body class for procurement mode (hide nav when in ProcurementLayout)
    try {
        const active = localStorage.getItem('active_module') || '';
        const path = to.path || '';
        // procurement dashboard uses normal layout - don't hide nav
        if (path === '/admin/procurement/analytics') {
            document.body.classList.remove('procurement-mode');
        } else if (active === 'procurement' || path.startsWith('/procurement') || path.startsWith('/admin/procurement')) {
            document.body.classList.add('procurement-mode');
        } else {
            document.body.classList.remove('procurement-mode');
        }
    } catch (e) {
        // ignore DOM access errors
    }
    next();
})

export default router;